const weightUnitConstants = {
	poundsAndOunces: 'Pounds and Ounces',
	kilograms: 'Kilograms',
};

const dimensionUnitConstants = {
	inches: 'Inches',
	meters: 'Meters',
};

// Short display forms for the full unit names above (e.g. "Inches" -> "in", "Pounds and Ounces" -> "lbs").
const unitAbbreviations = {
	[dimensionUnitConstants.inches]: 'in',
	[dimensionUnitConstants.meters]: 'm',
	[weightUnitConstants.poundsAndOunces]: 'lbs',
	[weightUnitConstants.kilograms]: 'kg',
};

// Returns the short form of a unit name, falling back to the original name (or '' when absent).
const abbreviateUnit = name => unitAbbreviations[name] || name || '';

export { weightUnitConstants, dimensionUnitConstants, unitAbbreviations, abbreviateUnit };
